import { makeAutoObservable } from 'mobx';
import { resetAllStore } from '../../shared/stores/resetAllStore';
import { ScanIqCustomerSetupInfo } from '../interfaces/ScanIqCustomerSetupInfo';

class ScanIqStore {
  customer: ScanIqCustomerSetupInfo | null = null;
  // Snapshot from 2FA verify response; kept stable through later customer updates
  // so the step-2 branch in NgzInBodyScanIq doesn't flip after PersonalInfoStep submit.
  initialCustomer: ScanIqCustomerSetupInfo | null = null;

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true });
  }

  setDefaultValues() {
    this.customer = null;
    this.initialCustomer = null;
  }

  setCustomer(customer: ScanIqCustomerSetupInfo) {
    this.customer = customer;
  }

  setInitialCustomer(customer: ScanIqCustomerSetupInfo) {
    this.initialCustomer = customer;
  }
}

const scanIqStore = new ScanIqStore();
resetAllStore.addResetMethod(scanIqStore.setDefaultValues);

export { scanIqStore, ScanIqStore };
